import type { Place } from "../../my-type";
import { ActionType } from "../action-types";
import { Action } from "../actions";
//import { User } from "../../my-type";


const placeReducer = (state: Place[] = [], action: Action) => {
  switch (action.type) {
    case ActionType.UPDATE_PLACE:
      return (state = action.payload);
    default:
      return state;
  }
}

export default placeReducer;
